'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
export default class Image extends PureComponent {
  render() {
    const props = this.props;
    let output = /*#__PURE__*/React.createElement("img", _extends({
      className: props.className || 'u-responsive-img'
    }, props));
    return output;
  }
}
Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  title: PropTypes.string,
  style: PropTypes.object
};
